import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Calendar from 'containers/calendar';
import Controller from './controller';
import RelativeWrapper from 'wrappers/relativeWrapper';
import DropdownOuterWrapper from 'wrappers/dropdownOuterWrapper';
import DropdownWrapper from 'wrappers/dropdownWrapper';
import internalState from './internalState';
import { ClickableIcon } from 'atoms';

const containerRef = React.createRef();

export const definition = {
  name: 'DatePicker',
  controller: Controller,
  initialProps: ({ icon }) => ({ icon }),
  props: internalState,
  elements: [
    {
      component: ClickableIcon,
      renderIf: ({ icon }) => !!icon,
      name: 'Icon',
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      displayValue: ({ icon }) => icon
    },
    {
      wrapper: DropdownOuterWrapper,
      name: "CalendarOuterWrapper",
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: DropdownWrapper,
          name: "CalendarWrapper",
          elements: [
            {
              component: Calendar,
              name: 'Calendar',
              bindings: ({ }) => ({})
            }
          ]
        }
      ]
    }

  ]
}

export default wrap(ContainerComponent(definition), RelativeWrapper)